import React, { useEffect, useState } from "react"

import useOnclickOutside from "react-cool-onclickoutside"
import { useLocation } from "react-router-dom"

import { PrimaryText } from "@front-shared/elements/primaryText.element.tsx"

import { ProduktlyHelper } from "../helpers/produktly.helper"
import type { IMenuItem } from "../types/objects.types.ts"
import { MenuItemElement } from "./menuItem.element.tsx"

import chevronDown from "@front-shared/assets/images/icons/chevron-down-dark-small.svg"

export const MenuDropdownElement: React.FunctionComponent<
    IMenuDropdownProps
> = props => {
    const containerRef = useOnclickOutside(() => {
        setIsSubmenuOpen(false)
    })

    const location = useLocation()

    const [isSubmenuOpen, setIsSubmenuOpen] = useState(false)
    const [isActive, setIsActive] = useState(false)

    const toggleSubmenu = () => {
        setIsSubmenuOpen(current => !current)
    }

    useEffect(() => {
        const active = props.items.some((item: IMenuItem) => {
            return item.url === location.pathname
        })

        setIsActive(active)
    }, [location.pathname, props.items])

    return (
        <div
            className={`
                relative
                ${props.className}
            `}
            ref={containerRef}
            data-produktly={`nav-${ProduktlyHelper.formatId(props.label)}`}
        >
            <div
                className="relative cursor-pointer flex items-center"
                onClick={toggleSubmenu}
            >
                <PrimaryText typography={isActive ? "textBold" : "text"}>
                    {props.label}
                </PrimaryText>

                {props.items.length > 0 && (
                    <img src={chevronDown} alt="Toggle" className="ml-[6px]" />
                )}
            </div>

            {isSubmenuOpen && (
                <div
                    className="
                        absolute w-[200px] z-100 bg-brand-offWhite top-[30px] left-0
                        rounded-[8px] border border-solid border-brand-warmShadow
                        shadow-6 overflow-hidden
                    "
                >
                    <div>
                        {props.items.map((item: IMenuItem, index: number) => {
                            return (
                                <MenuItemElement
                                    key={index}
                                    item={item}
                                    className="p-[16px]"
                                    activeClassName="bg-brand-lilacLight"
                                    inactiveClassName="bg-brand-white"
                                    onClick={toggleSubmenu}
                                    typography="buttonText"
                                />
                            )
                        })}
                    </div>
                </div>
            )}
        </div>
    )
}

interface IMenuDropdownProps {
    className?: string
    label: string
    items: IMenuItem[]
}
